/****************ELEMENTS*****************/
//this obj define, the actions realeted to each
//th>table header and td
const timeDate = require("../../../../../js-handler/time-date");

function getTdDataDetail(dest, entity, dbid) {
  return `data-detail='{ 
      "click": [ 
        {"dest":"ripple"},
        {"dest":"${dest}", "elem":"fullcont", "id":"${dest}-fullcont", "act":"selectOne", "entity":"${dest}", "dbid":"${dbid}"}
      ],
      "clickRight": [ 
        {"dest":"${dest}", "elem":"dt", "act":"trMenu", "id":"trMenu", "entity":"${dest}", "dbid":"${dbid}"}
      ] 
  }'`;
}

export const tableDetail = {

  entity: "clientActivity", //name table on the db
  dest: "clientActivity", //name of the entity on the system

  //action for body
  //left click, directly to the fullcont
  tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"clientActivity", "elem":"page", "act":"removeFc"}  ],
                                
                                 "clickRight": [{"dest":"purchase", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"purchase", "dbid": "#dbid" } ]  }'`,

  // andry 28/12/2023
  filter: {
    mainFilterFields: [
      "purchase.code",
      "provider.name",
      "purchase.reference_number",
      "item.name",
      "item.brand",
    ],
    mainFilterValues: ["", ""],
    andFilterFields: [""],
    andFilterValues: [""],
  },
};

/****************ELEMENTS*****************/

//each element could organize their data diferent
export function organizeRow(data) {
  var newData = [];

  if (data.length === 0) {
    newData.push({
      id: "nothing",
      colum: [
        { label: "No Results", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
        { label: "", span: "" },
      ],
    });
    return newData;
  }

  data.forEach((elem) => {
    let text;
    let subTextStatus;
    let textBill;
    let subTextBill;
    let paymentColor;
    let statusStyle;
    let billColor;
    let statusStyleBill;
    let subTextDueDate;
    let newEntity;

    let customAvatarLetter = 'NA'; // Valor por defecto
    let bgColor; // Valor por defecto
    if (elem.transactionType === 'purchase') {
      customAvatarLetter = './css/svg.svg#purchase';
      bgColor = '#36a2eb';
      newEntity = 'clientPurchase';
    } else if (elem.transactionType === 'sale') {
      customAvatarLetter = './css/svg.svg#sale';
      bgColor = '#46bb77ff';
      newEntity = 'clientSale';
    }

    const differenceInDays = timeDate.compareDates(elem.clientActivityDueDate);

    if (differenceInDays > 0) {
      subTextDueDate = differenceInDays + " " + "Days Left";
    } else if (isNaN(differenceInDays)) {
      subTextDueDate = "NA";
    } else {
      subTextDueDate = Math.abs(differenceInDays) + " " + "Days Over Due";
    }

    switch (elem.payment_status) {
      case "paid":
        text = "Paid";
        subTextStatus = "";
        paymentColor = "tdWithIcon td-green-icon";
        statusStyle = "./css/svg.svg#cash";
        break;

      case "unpaid":
        if (elem.shipping === "ordered") {
          text = "Unpaid";
          subTextStatus = "Payment needed";
          paymentColor = "tdWithIcon td-orange-icon";
          statusStyle = "./css/svg.svg#cash";
        } else {
          text = "--";
          subTextStatus = "No Payment needed";
          paymentColor = "tdWithIcon td-gray-icon";
          statusStyle = "./css/svg.svg#cash";
        }
        break;

      case "partially_paid":
        text = "Partially Paid";
        subTextStatus = "Payment needed";
        paymentColor = "tdWithIcon td-orange-icon";
        statusStyle = "./css/svg.svg#cash";
        break;

      case "close":
        text = "Close";
        subTextStatus = "be closed";
        paymentColor = "tdWithIcon td-lg-icon";
        statusStyle = "./css/svg.svg#cash";
        break;

      case "overdue":
        text = "overdue";
        subTextStatus = "Payment needed";
        paymentColor = "tdWithIcon td-red-icon";
        statusStyle = "./css/svg.svg#cash";
        break;

      case "credited":
        text = "Credited";
        subTextStatus = "Outstanding credit";
        paymentColor = "tdWithIcon td-orange-icon";
        statusStyle = "./css/svg.svg#cash";
        break;

      case "":
        text = "";
        subTextStatus = "";
        paymentColor = "tdWithIcon td-lg-icon";
        statusStyle = "./css/svg.svg#cash";
        break;

      default:
        break;
    }

    switch (elem.shipping) {
      case "ordered":
        textBill = "Ordered";
        subTextBill = "Orde placed";
        billColor = "tdWithIcon td-orange-icon";
        statusStyleBill = "./css/svg.svg#warning";
        break;

      case "shipped":
        textBill = "Shipped";
        subTextBill = "Comming";
        billColor = "tdWithIcon td-green-icon";
        statusStyleBill = "./css/svg.svg#truck";
        break;

      case "delivered":
        textBill = "Delivered";
        subTextBill = "On Site";
        billColor = "tdWithIcon td-gray-icon";
        statusStyleBill = "./css/svg.svg#check-round";
        break;

      default:
        textBill = "";
        subTextBill = "";
        billColor = "";
        break;
    }

    newData.push({
      id: elem.id,
      tdDataDetail: getTdDataDetail(newEntity, elem.transactionType, elem.id),
      colum: [
        {
          label: elem.providerName,
          span: elem.purchaseCodeREF_td,
          style: {
            tdClass: "tdWithAvatar",
            avatar: customAvatarLetter,
            svgBg: bgColor,
            avatarColor: '',
            avatarColorLetter: '',
            avatarLetter: ''
          },
        },

        { label: elem.general_total_price_dt, span: elem.total_expenses },

        {
          label: timeDate.friendlyDate(elem.purchaseDate),
          span: subTextDueDate,
        },

        {
          label: textBill,
          span: subTextBill,
          style: {
            tdClass: billColor,
            svg: statusStyleBill,
          },
        },

        {
          label: text,
          span: subTextStatus,
          style: {
            tdClass: paymentColor,
            svg: statusStyle,
          },
        },
      ],
    }); /*push*/
  }); /*forEach*/

  return newData;
}

export function organizeRowEntityChange(data) {
  let newData = "";
  let avatar = "";
  let changes_inputs;
  let changes_mt;

  data.forEach((elem) => {
    if (elem.avatar == "") {
      avatar = "css/img/pic/person.svg";
    } else {
      avatar = elem.avatar;
    }

    newData += `<cont> 
                        <user>
                            <photo class="photo" 
                            style="background-image: url('${avatar}')"></photo>
                            <title>${elem.user_name.trim()}</title>
                            <time>${timeDate.friendlyDate(elem.date_change) +
      " | " +
      timeDate.friendlyTime(
        elem.date_change.substring(10)
      )
      }</time>
                        </user>

                        <entry>
                            <div class="row">
                                <div class="c33">Data</div><!-- c16 -->
                                <div class="c33">From</div><!-- c16 -->
                                <div class="c33">To</div><!-- c16 -->
                            </div><!-- row --> 
        
                    `;

    changes_inputs = JSON.parse(elem.changes).input;

    changes_inputs.forEach((input) => {
      newData += `
                            <div class="row">
                                <div class="c33">${input.elemId}</div><!-- c16 -->
                                <div class="c33">${input.from}</div><!-- c16 -->
                                <div class="c33">${input.to}</div><!-- c16 -->
                            </div><!-- row --> 
            `;
    });

    changes_mt = JSON.parse(elem.changes).mt;
    if (changes_mt.length > 0) {
      newData += `     </entry>
                        <entry>
                            <div class="row mt-8">
                                <div class="c16">Status</div><!-- c16 -->
                                <div class="c16">Items</div><!-- c16 -->
                                <div class="c16">Units</div><!-- c16 -->
                                <div class="c16">Qty</div><!-- c16 -->
                                <div class="c16">Unit Price</div><!-- c16 -->
                                <div class="c16">Total</div><!-- c16 -->
                            </div><!-- row --> `;
    }

    changes_mt.forEach((mt) => {
      mt.from.forEach(function (mt_from, index) {
        newData += `
                    <div class="row">
                        <div class="c16">From</div><!-- c16 -->
                        <div class="c16">${mt_from.id}</div><!-- c16 -->
                        <div class="c16">${mt_from.selling_type
          }</div><!-- c16 -->
                        <div class="c16">${mt_from.qty}</div><!-- c16 -->
                        <div class="c16">${"$" + mt_from.price
          }</div><!-- c16 -->
                        <div class="c16">${"$" + mt_from.total
          }</div><!-- c16 -->
                    </div><!-- row -->`;

        // Verificar si hay datos en mt.to
        if (mt.to && mt.to[index]) {
          newData += `
                    <div class="row">
                        <div class="c16">To</div><!-- c16 -->
                        <div class="c16">${mt.to[index].id}</div><!-- c16 -->
                        <div class="c16">${mt.to[index].selling_type
            }</div><!-- c16 -->
                        <div class="c16">${mt.to[index].qty}</div><!-- c16 -->
                        <div class="c16">${"$" + mt.to[index].price
            }</div><!-- c16 -->
                        <div class="c16">${"$" + mt.to[index].total
            }</div><!-- c16 -->
                    </div><!-- row -->`;
        }
      });
    });

    newData += `     </entry>
                   <cont>`;
  }); /*forEach*/

  return newData;
} /*organizeRow*/
